module.exports = "https://bt2-static.vkplay.ru/promo/event/img/char.b71d763a.webp";